import React, { useEffect } from "react";
import { Table, Switch } from "antd";
import { ColumnsType } from "antd/es/table";
import { useTransactModel } from "./transactModel";
import { IAccountTransactDetail } from "../../AccountTypes";


const columns: ColumnsType<IAccountTransactDetail> = [
    {
        align: "center",
        title: '分支',
        dataIndex: 'branch',
    },
    {
        align: "center",
        title: '核销编号',
        dataIndex: 'code',
    },
    {
        align: "center",
        title: '本次核销总额',
        dataIndex: 'writeoffAmount',
    },
    {
        align: "center",
        title: '核销账户',
        dataIndex: 'accountName',
    },
    {
        align: "center",
        title: '账户实体',
        dataIndex: 'beName',
    },
    {
        align: "center",
        title: '核销人',
        dataIndex: '',
    },
    {
        align: "center",
        title: '核销时间',
        dataIndex: 'writeoffTime',
    },
    {
        align: "center",
        title: '从属机构',
        dataIndex: 'orgName',
    },
    {
        align: "center",
        title: '备注',
        dataIndex: 'note',
    },

];

export function TransactDataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys
    } = useTransactModel();


    return (
        <Table
            rowSelection={{
                type: "radio",
                onChange: (selectedRowKeys: React.Key[]) => {
                    setSelectedRowKeys(selectedRowKeys);
                },
                selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                showTotal: (total: number) => `共${total}条`,
                position: ["bottomCenter"],
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize }).then();
                }
            }}
            onRow={record => {
                return {
                    onClick: event => {
                        if (selectedRowKeys.length > 0 && selectedRowKeys[0] === record.key) {
                            setSelectedRowKeys([]);
                        } else {
                            setSelectedRowKeys([record.key]);
                        }
                    },
                };
            }}
            scroll={{ x: 'max-content' }}
        />
    )
}
